import {
  DELETE_INVESTMENT_HOLDING_INTEREST_ADJUSTMENT,
  GET_INVESTMENT_HOLDING_INTEREST_ADJUSTMENT,
  GET_INVESTMENT_HOLDING_INTEREST_ADJUSTMENT_LIST,
  POST_INVESTMENT_HOLDING_INTEREST_ADJUSTMENT,
  PUT_INVESTMENT_HOLDING_INTEREST_ADJUSTMENT,
  COPY_INVESTMENT_HOLDING_INTEREST_ADJUSTMENT_FROM_PREVIOUS_YEARS,
} from "../constants/actionTypes";

const defaultState = {
  interestAdjustmentArr:[],
  interestAdjustment:{}
};
let data=[]
export default (state = defaultState, action) => {
  try {
    switch (action.type) {
      case GET_INVESTMENT_HOLDING_INTEREST_ADJUSTMENT_LIST:
        return {...state,interestAdjustmentArr:[...action.payload]};
      case GET_INVESTMENT_HOLDING_INTEREST_ADJUSTMENT:
        return {...state,interestAdjustment:{...action.payload}};
      case POST_INVESTMENT_HOLDING_INTEREST_ADJUSTMENT:
        return {...state,interestAdjustmentArr:[...state?.interestAdjustmentArr,action.payload]};
      case PUT_INVESTMENT_HOLDING_INTEREST_ADJUSTMENT:
        data = [...state?.interestAdjustmentArr];
        index = data?.findIndex(
          (setting) => setting?.id_customer === action.payload?.id_customer,
        );
        if (index != -1) data[index] = { ...action?.payload };
        return {...state,interestAdjustmentArr: [...data]};
      case DELETE_INVESTMENT_HOLDING_INTEREST_ADJUSTMENT:
        data = [...state?.interestAdjustmentArr];
        const newData = data?.filter(
          (income) => income.id!=action.payload,
        );
        return {...state,interestAdjustmentArr: [...newData]};
      case COPY_INVESTMENT_HOLDING_INTEREST_ADJUSTMENT_FROM_PREVIOUS_YEARS:
        return {
          ...state,
          interestAdjustmentArr: Array.isArray(action.payload) 
            ? [...action.payload]
            : state.interestAdjustmentArr,
        };
      default:
        return state;
    }
  } catch (error) {
    throw new Error(error);
  }
};
